
export default function WhyProject() {
  const reasons = [
    {
      icon: 'ri-line-chart-line',
      title: 'Unstable Income Problem',
      description: 'Many people struggle with inconsistent earnings and lack of financial security in traditional employment.',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Rising Health Challenges',
      description: 'Health issues are increasing across Nigeria, creating a massive demand for wellness solutions.',
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'The Solution: Health + Structure',
      description: 'Combine a proven health business model with structured mentorship to create sustainable income.',
    },
  ];

  return (
    <section id="why-project" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Why The Monthly Millionaire Project?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-stone-50 rounded-xl p-8 hover:bg-stone-100 transition-all duration-300 transform hover:scale-105 hover:shadow-xl border border-stone-200"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-amber-500 rounded-full mb-6 mx-auto">
                <i className={`${reason.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">
                {reason.title}
              </h3>
              <p className="text-gray-600 text-center leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
